<template>
    <div>
        <Card>
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">客户统计分析</span>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Tabs :animated="false">
                    <TabPane label="订购数量"
                        name="orderQuantity">
                        <CustomerOrderQuantity  ref="customerOrderQuantity" />
                    </TabPane>
                    <TabPane label="订购次数"
                        name="orderCount">
                        <CustomerOrderCount ref="customerOrderCount" />
                    </TabPane>
                    <TabPane label="售价变化"
                        name="priceChange">
						<CustomerOrderPriceChange ref="customerOrderPriceChange"/>
						</TabPane>
                    <TabPane label="品种客户数量"
                        name="productCustomerQantity">
						<CustomerProductQantity ref="customerProductQantity"/>
						</TabPane>
                    <TabPane label="客户品种数量"
                        name="customerProductQantity">
						<CustomerQantityProduct ref="customerQantityProduct"/>
						</TabPane>
                </Tabs>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import CustomerOrderQuantity from './customer-order-quantity.vue';
import CustomerOrderCount from './customer-order-count.vue';
import CustomerOrderPriceChange from './customer-order-priceChange.vue';
import CustomerProductQantity from './customer-product-qantity.vue';
import CustomerQantityProduct from './customer-qantity-product.vue';

export default {
    name: 'sale-member-stat-list',
    components: {
        CustomerOrderQuantity,
        CustomerOrderCount,
        CustomerOrderPriceChange,
        CustomerProductQantity,
        CustomerQantityProduct
    },
    data() {
        return {
            innerSpin: false
        };
    },
    mounted() {
       
    },
    methods: {
        
    }
};
</script>

<style scoped>
</style>
